import React from 'react'
import { AnswerKeyQuestion } from './'

export default function AnswerKeyColumn({number, answers, answersByItem, items, startNumber}) {
  return (
    <div className={`column column-${number}`}>
      {
        items.map((item, n) => 
          <AnswerKeyQuestion 
            number={n + parseInt(startNumber, 10)}
            correctAnswer={answers[n + parseInt(startNumber, 10) - 1]}
            yourAnswer={answersByItem ? answersByItem[item.itemId] : ''}
            key={`ansKeyQ${item.itemId}`}
          />
        )
      }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/AnswerKeyColumn.js